import React, { Component } from 'react'
import { PrimaryQ, StyledA, SecondaryP } from './styled-components.js'

export default class Quote extends Component {
  render() {
    const { component } = this.props

    const CircleSVG = () => (
      <svg
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(-862.000000, -4985.000000)">
          <g id="circle" transform="translate(862.000000, 4985.000000)">
            <circle fill={component.primaryColor} cx="15" cy="15" r="15" />
          </g>
        </g>
      </svg>
    )

    return (
      <section className={`component quote margin-${component.marginBelow}`}>
        <div className="grid-row">
          <div
            className={`block width-${component.contentColumnWidth} shift-${
              component.shiftContent
            }`}
          >
            {component.circleCroppedImage ? (
              <div className="circle-crop">
                <img src={`${component.circleCroppedImage.file.url}`} />
              </div>
            ) : (
              <CircleSVG />
            )}
            <figcaption>
              {component.captionCopy && (
                <PrimaryQ
                  primaryTextColor={component.primaryColor}
                  dangerouslySetInnerHTML={{
                    __html: component.captionCopy.captionCopy,
                  }}
                />
              )}

              {component.quoteAuthorOrSocialHandle &&
              component.linkToAuthorOrSocialMedia ? (
                <StyledA
                  primaryTextColor={component.primaryColor}
                  secondaryTextColor={component.secondaryColor}
                  href={component.linkToAuthorOrSocialMedia}
                  target="_blank"
                >
                  {component.quoteAuthorOrSocialHandle}
                </StyledA>
              ) : component.quoteAuthorOrSocialHandle &&
              !component.linkToAuthorOrSocialMedia ? (
                <SecondaryP secondaryTextColor={component.secondaryColor}>
                  {component.quoteAuthorOrSocialHandle}
                </SecondaryP>
              ) : (
                ''
              )}
            </figcaption>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared-page-components/quote.js